import {selectDictByService} from "@/api/system/dict";

const actions = {
    /**
     * 获取课程专业字段树节点列表
     * @param dispatch
     */
    selectCourseMajorDict({commit}) {
        return new Promise((resolve, reject) => {
            selectDictByService({
                service: 'course_major'
            })
                .then(data => {
                    commit('SET_MAJOR_TREE_LIST', data)
                    resolve(data)
                })
                .catch(err => {
                    commit('SET_MAJOR_TREE_LIST', [])
                    reject(err)
                })
        })
    },
}

export default actions
